<template>
  <div>
    <div class="no-background container is-max-desktop pb-5">
      <HealthInsuranceHero class="mx-4" />
    </div>
    <BackgroundTop />
    <div class="full-width-background py-5">
      <div class="container is-max-desktop">
        <HealthInsuranceExplanation :health-insurance="HealthInsurances.aokPlus">
          <template #explanation-slot>
            Versicherte der AOK PLUS mit einer leichten kognitiven Störung oder einer milden Demenz erhalten die
            memodio-App gratis.
          </template>
        </HealthInsuranceExplanation>
      </div>
    </div>
    <HealthInsuranceSupportSection />
  </div>
</template>

<script>
import HealthInsuranceHero from "~/components/healthInsurance/HealthInsuranceHero.vue"
import HealthInsuranceSupportSection from "~/components/healthInsurance/HealthInsuranceSupportSection.vue"
import HealthInsuranceExplanation from "~/components/healthInsurance/HealthInsuranceExplanation.vue"
import BackgroundTop from "~/components/BackgroundTop.vue"
import HealthInsurances from "~/models/healthInsurances.js"

export default {
  name: "AokPlusReimbursement",
  components: {
    HealthInsuranceHero,
    HealthInsuranceSupportSection,
    HealthInsuranceExplanation,
    BackgroundTop,
  },
  computed: {
    HealthInsurances() {
      return HealthInsurances
    },
  },
  methods: {
    goToContact() {
      this.$router.push(this.localePath("ContactForm"))
    },
  },
}
</script>

<style scoped lang="scss"></style>
